<template>
  <v-app id="inspire">
    <v-main>
      <v-container
          class="fill-height pa-0 blue-grey"
          fluid
      >
        <v-row
            class="fill-height"
            align="center"
            justify="center"
        >
          <v-col
              cols="12"
              sm="8"
              md="4"
          >
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title>Pin It</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                >
                  <v-text-field
                      dense
                      outlined
                      v-model="email"
                      :rules="emailRules"
                      label="E-mail"
                      autocomplete="on"
                      required
                      v-on:keypress="keyPress"
                  ></v-text-field>

                  <v-text-field
                      dense
                      outlined
                      v-model="password"
                      :append-icon="eye ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="passwordRules"
                      :type="eye ? 'text' : 'password'"
                      label="Senha"
                      required
                      autocomplete="on"
                      v-on:keypress="keyPress"
                      counter
                      @click:append="eye = !eye"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <reset-password-modal
                    text
                    small
                    title="Recuperação de senha"
                    description="Informe o email cadastrado que enviaremos um email de recuperação de senha."
                    action-text="Esqueceu sua senha?"
                    :onSuccess="onResetPasswordSuccess"
                />
                <v-spacer/>
                <v-btn
                    :disabled="!valid"
                    :loading="loading"
                    color="primary"
                    @click="submit"
                    class="px-5"
                >
                  Entrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import ResetPasswordModal from '@/components/ResetPasswordModal'
import {handleResponseError} from '@/api/handleError'

export default {
  name: 'Auth',
  components: {
    ResetPasswordModal
  },
  data: () => ({
    eye: false,
    snackbar: {
      text: '',
      show: false,
      color: '',
    },
    valid: false,
    loading: false,
    email: '',
    emailRules: [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'E-mail inválido',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Senha é obrigatória',
    ],
  }),
  methods: {
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    keyPress: function (e) {
      if (e.keyCode === 13) this.submit()
    },
    submit: async function() {
      if (!this.$refs.form.validate()) return
      this.loading = true
      try {
        await this.$store.dispatch('auth/login', {email: this.email, password: this.password})
            .then(() => {
              this.loading = false
              this.$router.push('/dashboard').catch(e => console.error(e))
            })
            .catch(e => {
              this.loading = false
              const message = handleResponseError(e)
              this.showNotification(message, 'red darken-2')
            })
      } catch (e) {
        const message = handleResponseError(e)
        this.showNotification(message, 'red darken-2')
      }
    },
    onResetPasswordSuccess: function() {
      this.showNotification('Email enviado! Caso não encontre verifique a caixa de spam', 'green')
    }
  },
}
</script>

<style scoped>
.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
